import * as vp from 'vopay';

import { FunctionComponent, useContext, useMemo } from 'react';
import FileUploadContext from './FileUploadContext';

import { DialogueHandler, FileUploadDialogueHandlers } from './types';

const { ConfirmationDialogue } = vp;

type FileUploadDialogueProps = {
  handleDialogue: DialogueHandler<FileUploadDialogueHandlers>;
};

type FC = FunctionComponent<FileUploadDialogueProps>;

const TicketCreationDialogue: FC = ({ handleDialogue }: FileUploadDialogueProps) => {
  const { showInvalidFileAlert, showInvalidSizeAlert, showFileUploadAlert, fileUploadError } =
    useContext(FileUploadContext);
  return useMemo(
    () => (
      <div>
        {/* Delete User Error */}

        <ConfirmationDialogue
          isVisible={showFileUploadAlert}
          title="Error! The file was not successful uploaded."
          status="error"
          subTitle={`${fileUploadError}`}
          confirm={{
            label: 'Back to File Upload',
            action: () => handleDialogue({ type: 'upload', state: 'fail' }),
          }}
        />
        {/* invalid File */}

        <ConfirmationDialogue
          isVisible={showInvalidFileAlert}
          title="Error! The file was not successful uploaded."
          status="error"
          subTitle="Invalid file format"
          confirm={{
            label: 'Back to File Upload',
            action: () => handleDialogue({ type: 'upload', state: 'invalid' }),
          }}
        />
        {/* Invalid File Size */}

        <ConfirmationDialogue
          isVisible={showInvalidSizeAlert}
          title="Error! The file was not successful uploaded."
          status="error"
          subTitle="The file contains no transaction"
          confirm={{
            label: 'Back to File Upload',
            action: () => handleDialogue({ type: 'upload', state: 'size' }),
          }}
        />
      </div>
    ),
    [showInvalidFileAlert, showInvalidSizeAlert, showFileUploadAlert],
  );
};

export default TicketCreationDialogue;
